import React from 'react';
import TableRowWithTooltip from 'features/shared/TableRowWithTooltip';
import { RowProps } from './models';
import { ColoredCell, ResultsRow } from 'features/shared/ui/Table';
import { ReactComponent as Plus } from './Plus.svg';
import { StudentCountCell } from './StudentCountCell';
import { Exclamation } from './styles';
import Tooltip, { TooltipPlacement, TooltipProps } from 'features/shared/Tooltip';

interface Props extends RowProps {
  isRegion: boolean;
  abTest: boolean;
}

export const Row = ({
  location,
  school,
  registeredTeachers,
  activeTeachers,
  registeredStudents,
  activeStudents,
  schoolsCount,
  studentCount,
  isRegion,
  schoolId,
  setStudentCount,
  subjectName,
  involvementLowered,
  involvementPercent,
  abTest
}: Props & { setStudentCount: (id: number | null, value: number) => void; subjectName?: string }) => (
  <ResultsRow
    warning={abTest && involvementLowered}
    noResults={!registeredStudents && !activeStudents && !registeredTeachers && !activeTeachers}
  >
    <td style={{ textAlign: 'start', paddingLeft: '16px', paddingRight: '16px' }}>
      <TableRowWithTooltip>{location}</TableRowWithTooltip>
    </td>
    {isRegion ? (
      <>
        <td style={{ textAlign: 'center', paddingLeft: '16px', paddingRight: '16px' }}>
          <div>{schoolsCount}</div>
        </td>
      </>
    ) : (
      <>
        <td style={{ textAlign: 'start', paddingLeft: '16px', paddingRight: '16px' }}>
          {abTest && involvementLowered ? (
            <Tooltip
              title={`Снижение активности на\u00A0${Math.abs(involvementPercent || 0)}%`}
              arrow
              placement="top"
              maxWidth={400}
            >
              <Exclamation style={{ float: 'left', marginRight: 8, marginTop: 2 }} />
            </Tooltip>
          ) : null}
          <TableRowWithTooltip>{school}</TableRowWithTooltip>
        </td>
      </>
    )}
    <ColoredCell>{registeredTeachers}</ColoredCell>
    <ColoredCell style={{ borderLeft: 'none' }}>{activeTeachers}</ColoredCell>
    {isRegion ? (
      <>
        <ColoredCell>{registeredStudents}</ColoredCell>
      </>
    ) : (
      <>
        <ColoredCell>
          <StudentCountCell
            id={schoolId}
            schoolLocation={location}
            schoolName={school}
            studentCount={studentCount}
            setStudentCount={setStudentCount}
            subjectName={subjectName}
          />
        </ColoredCell>
        <ColoredCell style={{ borderLeft: 'none' }}>{registeredStudents}</ColoredCell>
      </>
    )}
    <ColoredCell style={{ borderLeft: 'none' }}>{activeStudents}</ColoredCell>
  </ResultsRow>
);
